import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import Config from './util/config';

const setup = (elementId: string): void => {
    const element: HTMLElement = document.getElementById(elementId);


    if (window.calendarInitiliased) {
        return
    }
    if (!element)
        return

    try {
        Config.setAll(JSON.parse(atob(element.dataset['options'])));
    } catch (err) {
        // JSON parse failed we don't care
        console.error(err)
    }

    window.calendarInitiliased = true

    ReactDOM.render(
        <App />,
        element
    );
}

export default {
    setup,
}
